<template>
	<div class="one-row" id="main-content">
		<div class="box qr-box" v-if="!displayForm">
			<span class="box-title">{{ $t('qr_code_box_title') }}</span>

			<img class="qrcode" src="../assets/images/qrcode-login.png" v-if="$parent.showLoginQR">
			<img class="qrcode" src="../assets/images/qrcode.png" v-else>

			<span class="box-subtitle">https://account.kidjo.tv/ {{ $parent.showLoginQR ? "login" : "register" }}</span>

			<button class="green-button submit-button animated-button qr-button" @click="displayForm = true">
				<span>{{ $t('register_page_form_login_link') }}</span>
			</button>
		</div>

		<div class="box login-box form-box" v-if="displayForm">
			<span class="box-title">{{ $t('login_page_box_title') }}</span> 
			
			<!-- <span class="box-subtitle">{{ $t('login_page_box_subtitle') }}</span> -->
			<form class="form" @submit.prevent="handleSubmit">
				<span class="box-subtitle" :class="$i18n.locale === 'ar' ? 'box-subtitle-right' : ''">{{ $t('login_page_box_form_email') }}</span>
					<TextInputField 
						:modelValue="email"
						@update:modelValue="email = $event"
						:field-type="'text'"
						name="email"
						:placeholder="''" 
						:has-error="email_error"
						:is-required-value="true"
					/>

					<span class="box-subtitle" :class="$i18n.locale === 'ar' ? 'box-subtitle-right' : ''">{{ $t('login_page_box_form_password') }}</span> 
						<TextInputField 
							:modelValue="password"
							@update:modelValue="password = $event"
							:field-type="'password'"
							name="password"
							:placeholder="''" 
							:has-error="password_error"
							:is-required-value="true"
						/>
				<router-link class="forgot-password" to="/forgotten-password" v-if="!$parent.tvPlatform">{{ $t('login_page_box_form_forgotten_password_link') }}</router-link>
				<SubmitButton :label="$t('login_page_box_form_submit')" :isLoading="loading" />
				<!-- <span class="form-small-text" v-if="!$parent.tvPlatform">
					{{ $t('login_page_box_form_no_account_text') }} <br>
					<router-link to="c" class="btn">{{ $t('login_page_box_form_create_account') }}</router-link>
				</span> use this lable in header button-->

				<a href="" class="form-small-text qr-link" @click.prevent="displayForm = false" v-if="$parent.tvPlatform">{{ $t('qr_code_go_to_code') }}</a>
			</form>

		</div>
	</div>

</template>
<script>
	import AuthService from '../services/auth.service';
	import PasswordService from '../services/password.service';
	import TextInputField from '../components/TextInputField.vue';
	import SubmitButton from '../components/SubmitButton.vue';
	import { Events } from '../utils/analytics';
	export default {
		components: {
			"TextInputField": TextInputField,
			"SubmitButton": SubmitButton
		},
    data() {
			return {
				email: '',
				password: '',
				email_error: false,
				password_error: false,
				loading: false,
				displayForm: true
			}
		},

		computed: {
			userEmail: function() {
				return this.$store.getters.getCurrentAccountEmail;
			},
			isDisabled: function() {
				var email, password;

				if (this.email !== '') {
					email = true;
				}

				if (this.password !== '') {
					password = true;
				}

				if (email && password) {
					return true;
				}
				return false;
			}
		},

		methods: {
			handleSubmit: async function() {
				this.loading = true;
				var has_error = this.checkFields();

				if(!has_error) {
					const hash = PasswordService.SHA256(this.password);
					var data = {'email': this.email, 'password': hash, 'countryCode': this.$parent.countryCode};

					const logged = await this.$store.dispatch('loginUser', data);

					if (logged !== true) {
						this.loading = false
						return this.handleError(logged);
					}
					await this.$store.dispatch('checkUserSubscriptions').then(() => {
						this.$parent.hasPremium = true;
						this.loading = false;
					}).catch((error) => {
						if (error.status === 404) {
							this.$parent.showFlashMessage(this.$t('profile_page_error_finding_subscription'));
						}

						if (error.status === 400) {
							this.$parent.showFlashMessage(this.$t('error_message_something_went_wrong'));
						}
					});
					// if (this.$parent.hasPremium !== true) {
					// 	if (this.$parent.hasPremium.status === 404) {
					// 		this.$parent.showFlashMessage(this.$t('profile_page_error_finding_subscription'));
					// 	}

					// 	if (this.$parent.hasPremium.status === 400) {
					// 		this.$parent.showFlashMessage(this.$t('error_message_something_went_wrong'));
					// 	}
					// }
					this.$parent.checkPremium();
				}
			},

			handleError: function(response) {
				if(response.status == 404) {
					this.$parent.showFlashMessage(this.$t('error_message_user_not_found'));
				}

				if (response.status == 400 && response.data.code == 1) {
					this.$parent.showFlashMessage(this.$t('error_message_wrong_password'));
				}
			},

			checkFields: function() {
				var has_error = false;

				if (this.email === '') {
					this.email_error = true;
					has_error = true;
				}

				if (this.password === '') {
					this.password_error = true;
					has_error = true;
				}

				return has_error;
			},
			routeBackToWebApp: function(appName) {
				const actionMap = {
					['games']: process.env.VUE_APP_GAMES_APP_URL,
					['stories']: process.env.VUE_APP_STORIES_APP_URL,
					['tv']: process.env.VUE_APP_WEB_APP_URL,
					['kidjo-world']: process.env.VUE_APP_WEB_APP_LINK
				};
				return actionMap[appName];		
			}
		},

		mounted: function() {
			if (this.$store.getters.getToken !== false) {
				if (this.$store.getters.getPremium === false) {
					
						this.$router.push({name: 'subscribe'}).catch(()=>{});
					
				} else {
					if(localStorage.getItem('app')) { 
						var appName = localStorage.getItem('app')
						localStorage.removeItem('app')
						AuthService.generateRedirectKey()
						.then((response) => {
							if (response.status === 200) {
								this.$parent.loading = false;
								// this.$store.dispatch('postAnalytics', Events.EXIT);
								window.location.replace(this.routeBackToWebApp(appName) + '?key='+response.data.redirectKey);
							}
						}).catch((error) => {
							this.$parent.loading = false;
						});
					} else {
						this.$router.push({name: 'profile'}).catch(()=>{});
					}
				}
			}

			// If coming from tv platform, show QR first
			if (this.$parent.tvPlatform) {
				this.displayForm = false;
			}

			if (this.$parent.appStyle == 'subscribe') {
				this.$parent.changeAppStyle('profile');
			}
		}
	}
</script>
